/** Форма відповідей API — спільна для сервера, вебу й бота. */
export const PRESENCE_PATH = '/api/presence';
export const EVENT_STREAM_PATH = '/api/events';
//# sourceMappingURL=api.js.map